import { trpc } from "../trpc";

interface Input {
  zapIds: string[];
}

interface Return {
  zaps: {
    id: string;
    requiresApproval: boolean;
    draftRequiresApproval: boolean;
    publishedRequiresApprovals: boolean;
    approvers: {
      email: string;
      name: string;
      role: string;
    }[];
  }[];
  isLoading: boolean;
  isPending: boolean;
}

function useRequiresApprovals({ zapIds }: Input): Return {
  const { data, isLoading, isPending } =
    trpc.approval.requiresApprovals.useQuery(
      {
        zapIds,
      },
      { enabled: zapIds.length > 0 },
    );

  // Handle union type: either array of zaps or error object with detail
  const isErrorResponse = data && !Array.isArray(data) && "detail" in data;

  return {
    zaps: isErrorResponse
      ? [] // Return empty array for error cases
      : (data?.map((zap) => ({
          id: zap.id,
          requiresApproval: zap.requiresApproval,
          draftRequiresApproval: zap.draftRequiresApproval,
          publishedRequiresApprovals: zap.publishedRequiresApproval,
          approvers: zap.approvers,
        })) ?? []),
    isLoading,
    isPending,
  };
}

export default useRequiresApprovals;
